import { render } from "./CertificateSuccess.vue?vue&type=template&id=78491bd4&scoped=true"
import script from "./CertificateSuccess.vue?vue&type=script&lang=js"
export * from "./CertificateSuccess.vue?vue&type=script&lang=js"

import "./CertificateSuccess.vue?vue&type=style&index=0&id=78491bd4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78491bd4"]])

export default __exports__